import api from "./api";

// ASSUMPTION: no BankDetailsController was shared, so this mirrors the
// /user/{id} convention WalletController actually uses. Swap these two
// routes if the real controller differs.
export const getUserBankDetails = async (userId) => {
  try {
    const res = await api.get(`/bankdetails/user/${userId}`);
    return res.data?.data ?? null;
  } catch (err) {
    if (err.response?.status === 404) return null;
    throw err;
  }
};

export const saveUserBankDetails = async (userId, details) => {
  const res = await api.post("/bankdetails", { ...details, userId });
  return res.data;
};
